<cb-dialog dialogHeading="Edit Contract Parties">
    <form class="cb-margin flex-col flex"
          #lotDetailsForm="ngForm">
        <div class="flex flex-50 flex-col">
            <cb-vendors-input-find-cards label="Vendor"
                                         name="selectedVendor"
                                         [(ngModel)]="mappedItem.vendorClientAccount"
                                         [text]="mappedItem.vendorClientAccount?.legalName"
                                         [removeable]="false"
                                         [disabled] = "!canEdit() || isChild(mappedItem)"
                                         (change)="vendorChanged($event)">
            </cb-vendors-input-find-cards>
        </div>
        <div class="flex-row layoutGap-30">
            <div class="flex flex-50">
                <cb-select name="businessEntities"
                           [matTooltip]="getChangeBusinessEntityDisabledReason()"
                           matTooltipPosition="above"
                           [(ngModel)]="mappedItem.businessEntityId"
                           label="Build Partner / Business Entities"
                           [disabled] = "!canEditBusinessEntities(mappedItem) || isChild(mappedItem) || childLotCannotChangeBusinessEntity"
                           [options]="availableBusinessEntities"
                           [wholeOptionComparisonProp]="'id'"
                           (change)="handleBusinessEntityChanged($event)">
                </cb-select>
            </div>
        </div>
        <div class="flex flex-50">
            <cb-display-value-new label="Job Number">
                {{mappedItem.jobNumber}}
            </cb-display-value-new>
        </div>
        @if (hasChildLots) {
            <div class="flex flex-50">
                <cb-display-value-new label="Unit Job Numbers">
                    @for (childLotJobNumber of childLotsJobNumbers; track childLotJobNumber; let last = $last) {
                        {{childLotJobNumber.label}}
                        @if (!last) {
                            ,
                        }
                    }
                </cb-display-value-new>
            </div>
        }
        <mat-checkbox
            [(ngModel)]="mappedItem.isNationallyManaged"
            name = "isNationallyManaged"
            [disabled] = true>
            Nationally Managed
        </mat-checkbox>
    </form>
    <div actions>
        <span [matTooltip]="getChangeLotDisabledReason()"
              matTooltipPosition="above"
        class="cb-margin-right">
          <button mat-raised-button
                  color="primary"
                  [disabled]="isChild(mappedItem) || lotDetailsForm.pristine || lotDetailsForm.invalid || saveInProgress"
                  (click)="updateContractParties()">
            Save
          </button>
        </span>
        <button mat-raised-button
                (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
